import axiosWrapper, { baseUrl } from './core';

const BASE_URL = '/api/payment-options';

export const getAllPayments = () =>
  axiosWrapper.get(`${baseUrl}${BASE_URL}/get-all`);
